import { useSyncExternalStore } from 'react';

import { expVal } from '@confluence/feature-experiments';

const TRACKED_NETWORK_EVENTS: (keyof WindowEventMap)[] = ['load', 'online', 'offline'];

const isOnlineSubscribe: Parameters<typeof useSyncExternalStore<boolean>>[0] = (callback) => {
	TRACKED_NETWORK_EVENTS.forEach((event) => window.addEventListener(event, callback));
	return () => {
		TRACKED_NETWORK_EVENTS.forEach((event) => window.removeEventListener(event, callback));
	};
};

const isOnlineGetSnapshot: Parameters<typeof useSyncExternalStore<boolean>>[1] = () =>
	navigator.onLine;

// During SSR rendering, we can't check the navigator status, so instead we'll assume the user is online
const isOnlineGetServerSnapshot: Parameters<typeof useSyncExternalStore<boolean>>[2] = () => true;

export const useEditorNetworkState = () => {
	const isOnline = useSyncExternalStore(
		isOnlineSubscribe,
		isOnlineGetSnapshot,
		isOnlineGetServerSnapshot,
	);

	return {
		isNetworkDisabled: expVal('platform_editor_offline_editing_web', 'isEnabled', false)
			? !isOnline
			: false,
	};
};
